// This file is not a route directly; it is used as the root notFoundComponent.
import { Button } from "@elit-hair/elit-ui";
import { useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {
    const { t } = useTranslation();
    const router = useRouter();

    return (
        <div className="flex flex-col items-center justify-center h-full gap-4">
            <h2 className="text-4xl font-bold text-primary">{t("404_title")}</h2>
            <p className="text-muted-foreground">{t("not_found_message")}</p>

            <Button
                variant="default"
                className="mt-4"
                size="lg"
                onClick={(e) => {
                    e.preventDefault();
                    router.history.back();
                }}
                disabled={!router.history.canGoBack()}
            >
                {t("go_back")}
            </Button>
        </div>
    );
};
